import {
  EvolutionState,
  EvolutionStateItem,
} from "@/redux/evolutions/evolutionsSlice";

import axios from "../../privateApi";

interface UpdateEvolutionStatesArgs {
  evolutions: EvolutionStateItem[];
}

export const updateUserEvolutionStates = ({
  evolutions,
}: UpdateEvolutionStatesArgs) => {
  return axios.patch(`/user-evolutions/evolutions`, { evolutions });
};
